let instance = null;

export function registerReader(ref) {
  if (!instance) {
    instance = ref;
  }
}

export function toggleReader() {
  if (instance) {
    instance.toggle();
  }
}

export function resetReader() {
  if (instance) {
    instance.reset();
  }
}

export function showReader() {
  if (instance) {
    instance.show();
  }
}

export function hideReader() {
  if (instance) {
    instance.hide();
  }
}

export function unregisterReader(ref) {
  if (instance === ref) {
    instance = null;
  }
}
